import { IApplicationTab } from "../interfaces/IApplicationTab";

export const APPLICATION_TABS: IApplicationTab[] = [
  {label: 'Анкета', value: '1',}, 
  {label: 'Учредители', value: '2',}, 
  {label: 'Финансы', value: '3',}, 
  {label: 'Документы', value: '4',}, 
  {label: 'Предложение', value: '5',},
  {label: 'Чат', value: '6', disabled: true,},
  {label: 'История', value: '7', disabled: true,}
];
